import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const routePrefix = "/orbmigratie/";

const OrbMigratieApi = {
    link(aanmeldCodes) {
        const serviceUrl = prependRoot(routePrefix + "link", getApiRoot());
        return axios.post(serviceUrl, { aanmeldCodes }, {
            headers: {
                'accept': 'application/json'
            }
        });
    },
    migrate(nieuweAccountId, oudeAccountIds) {
        const serviceUrl = prependRoot(routePrefix + nieuweAccountId, getApiRoot());
        return axios.post(serviceUrl, { oudeAccountIds }, {
            headers: {
                'accept': 'application/json'
            }
        });
    }
};

export default OrbMigratieApi;
